import { AccountResponse } from '../structures/response/AccountResponse';
import apiClient from './apiClient';
import { AccountProfileResponse } from '../structures/response/AccountProfileResponse';
import { AccountType } from '../enum/AccountType';
import { AccountSubjectResponse } from '../structures/response/AccountSubjectResponse';
import { makeConfig } from '../helpers/Helper';
import { AccountAddressResponse } from '../structures/response/AccountAddressResponse';
import { AccountAddressRequest } from '../structures/request/AccountAddressRequest';

const apiUrlConfig = makeConfig();

export const ownAccount = (
  additionalExtraFields?: string[]
): Promise<AccountResponse> => {
  let extraFields = ['profile', 'bankAccount', 'director', 'person'];

  if (Array.isArray(additionalExtraFields)) {
    extraFields = [...extraFields, ...additionalExtraFields];
  }

  const expand = extraFields.join(',');
  const url = `account/own-account?expand=${expand}`;
  return apiClient.get(url).then((r) => r.data);
};

export const updateProfile = (data: Partial<AccountProfileResponse>) =>
  apiClient.patch('account/profile/update-profile', data).then((r) => r.data);

export const updateAccountType = (
  type: AccountType
): Promise<AccountResponse> =>
  apiClient
    .patch('account/default/update-account?expand=person,director', { type })
    .then((r) => r.data);

export const updateSubject = (subject: Partial<AccountSubjectResponse>) =>
  apiClient
    .patch(`account/subject/update-subject?id=${subject.id}`, subject)
    .then((r) => r.data);

export const createSubject = (subject: Partial<AccountSubjectResponse>) =>
  apiClient
    .patch('account/subject/create-subject', subject)
    .then((r) => r.data);

export const changeEmail = async (email: string): Promise<void> =>
  apiClient
    .patch('account/change-email', {
      email,
      url: `${apiUrlConfig.apiUrl}/lk-agent/#/emailConfirm/{token}`,
    })
    .then((r) => r.data);

export const updateAccountAddress = async (
  params: AccountAddressRequest
): Promise<AccountAddressResponse> =>
  apiClient
    .patch('account/default/update-account-address', params)
    .then((r) => r.data);

export const setAgentInn = async (
  inn: string
): Promise<AccountAddressResponse> =>
  apiClient.patch('agent/agent/set-agent-inn', { inn }).then((r) => r.data);
